// extracted by mini-css-extract-plugin
export default {"image":"k2-z","loaded":"l2-z"};